import Freshpaint, { apiObject } from 'index';

export const makeTrackingFunction = <T extends FreshpaintEvent>(eventName: T['eventName']) =>
  (payload: T['payload']) => {
    track({
      eventName,
      payload
    });
  };

export const track = (event: FreshpaintEvent) => {
  if (typeof freshpaint === 'undefined') {
    return;
  }

  freshpaint.track(event.eventName, event.payload);
};


export type FreshpaintEvent = {
  eventName: string;
  payload: apiObject;
};

const { freshpaint } = window;

export const useFreshpaint = (): Freshpaint | null => {
  if (typeof freshpaint === 'undefined') {
    return null;
  }

  return freshpaint;
};
